export const texts = {
  es: {
    title: "Perfil inversor",
    subtitle: "El riesgo a tomar según el tipo de inversiones",
    tableTitle: "¿Qué implica cada riesgo?",
    primaryButton: "Aceptar",
    secondaryButton: "Volver",
  },
  en: {
    title: "Investor profile",
    subtitle: "Risk being taken given the kind of investments",
    tableTitle: "What does each risk profile imply?",
    primaryButton: "Accept",
    secondaryButton: "Back",
  },
};
